const DefaultState = {lang:'ch'}

export default function config(state = DefaultState, action) {
  let {type,url,data,key} = action
  switch(type) {
    case 'logout':
      return DefaultState

    case 'config':
      if(state[key]===data)
        return state
      return {...state,[key]:data}

    default:
      return state
  }
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/config.js
 **/